import React from "react";
import { Box, Typography } from "@mui/material";

const HeaderSection = () => {
  return (
    <Box mb={4}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", color: "#4d4d4d" }}>
        Sistema de Gestión de Estudiantes
      </Typography>
      <Typography variant="subtitle1" color="text.secondary">
        Edita y administra la información de los usuarios 🎨
      </Typography>
      
    </Box>
  );
};

export default HeaderSection;